import * as React from 'react';
import styled, { css } from 'styled-components';
import Badge from './Badge';
import exclamation from '../images/exclamation.svg';

const AlertBadges = styled(Badge)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 5;
`;

const AlertIcon = styled.div`
  ${(props: { url: string }) => {
    return css`
      width: 16px;
      height: 16px;
      background: url(${props.url});
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      justify-self: flex-end;
      margin: 2px;
      @media screen and (max-width: 330px) {
        width: 6px;
        height: 11px;
      }
    `;
  }}
`;

export default function AlertBadge() {
  return (
    <AlertBadges>
      <AlertIcon url={exclamation} />
    </AlertBadges>
  );
}
